var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"size-name"},[_vm._v(_vm._s(_vm.size.name))]),_c('div',{staticClass:"size-price"},[_vm._v(_vm._s(_vm.size.price))])])
}
var staticRenderFns = []

export { render, staticRenderFns }